import type { SVGProps } from 'react';

type GooglePlayIconProps = SVGProps<SVGSVGElement>;

export const GooglePlayIcon = ({ width = 27, height = 27, ...props }: GooglePlayIconProps) => (
  <svg
    width={width}
    height={height}
    viewBox="-6.5 -0.016 100.001 100.001"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fill="#08B059"
      d="M49.997 47.153l12.778-12.779C39.436 20.552 4.949.274 3-.016L2.844 0l47.153 47.153z"
    />
    <path
      fill="#1BB899"
      d="M.016 2.829L0 2.984v94l.015.149 47.153-47.152L.016 2.829z"
    />
    <path
      fill="#F04F3E"
      d="M50.003 52.816L2.852 99.968l.148.017c1.958-.312 36.439-20.58 59.775-34.396L50.003 52.816z"
    />
    <path
      fill="#F99C1C"
      d="M84 46.984s-7.372-4.398-17.665-10.5L52.832 49.988l13.497 13.497C76.625 57.382 84 52.984 84 52.984c1.607-.844 3-1.343 3-3 0-1.656-1.584-2.225-3-3z"
    />
  </svg>
);

export default GooglePlayIcon;
